import openModal from '@PROJECT_ROOT/assets/shared/js/modalBox';
import { FRAME_OFFSET_CHANGED } from '@PROJECT_ROOT/assets/shared/js/partnerToFrameMessageTypes';
import { heightChanged, legacyHeightChanged } from '@PROJECT_ROOT/assets/shared/js/frameToPartnerMessageTypes';
import { getMessageDataAsObject, getFrameOffset } from '@PROJECT_ROOT/assets/shared/js/partnerMessaging';
import calculateToastMessageDuration from '@PROJECT_ROOT/assets/mobile/js/ToastCalculator';
import ToastMessage from '@PROJECT_ROOT/assets/mobile/js/ToastMessages';
import '@PROJECT_ROOT/assets/mobile/js/jquery/jquery.modal.min';
import { isFrame } from '@PROJECT_ROOT/assets/shared/js/isPartnerService';

/*! Adriatic Library */
/* global lib, Cookies, ga */
window.lib = {};
lib.$win = $(window);
lib.onDocumentLoad = {
    init: function init(options) {
        const self = this;
        self.options = options;
        const $pageLoader = $('#pageLoader');

        $.ajaxSetup({
            cache: true,
        });

        // facebook dodaje fragment _=_ na URL nakon callbacka
        // uklanjamo taj dodatak
        if (window.location.hash && window.location.hash === '#_=_') {
            window.location.hash = '';
        }

        // Hack to hide loader on mobile back/forward button click
        lib.$win.on('unload', () => {});
        lib.$win.on('pageshow', () => {
            $pageLoader.hide();
        });

        // Hide loader
        $pageLoader.hide();

        // Language switch
        $(document).on('change', '#langSelect', function langSelect() {
            let url = $(this).val();
            $pageLoader.show();

            if (window.location.hash.length > 1) {
                url += window.location.hash;
            }

            window.location.href = url;
        });

        $(document).on('click', '.loading', () => {
            $pageLoader.show();
        }).on('click', '.redirectDesktop', function redirectDesktop() {
            Cookies.set('mobile_site', '0', {
                domain: $(this).data('cookie-domain'),
            });
        });

        // zaobilaženje iOS-evog zoomiranja input polja sa font-size < 16px
        if (window.innerWidth < 600) {
            $(document).on('mouseover', 'input, select, textarea', function saveFontSize() {
                const $input = $(this);
                // zabilježi postojeći font-size
                $input.data('fontSize', $input.css('font-size'));
                // postavi font-size na 16px
                $input.css('font-size', '16px');
            });

            $(document).on('blur', 'input, select, textarea', function setFontSize() {
                const $input = $(this);
                // vrati font-size na početnu vrijednost
                $input.css('font-size', $input.data('fontSize'));
            });
        }

        lib.mainMenu.init(options);
        lib.eventTracking.init();
    },
};

lib.mainMenu = {
    options: {},
    init: function init(options) {
        const self = this;
        self.options = options;

        $('#header').on('click', '#searchBtn, #menuBtn, #languageSwitch', function switchActive() {
            lib.mainMenu.switchActive($(this));
            window.parent.postMessage(heightChanged(), '*');
            window.parent.postMessage(legacyHeightChanged(document), '*');
        });

        $('#mainMenuWrap').on('click', '.subMenuToggle, .subMenuToggle2', function toggleSubMenu(e) {
            e.preventDefault();
            const toggleBtn = $(this);
            const parentLi = toggleBtn.parent();
            if (parentLi.hasClass('active')) {
                parentLi.find('.subMenu').slideUp(300);
                parentLi.removeClass('active');
                $(this).children('.subMenuArrow, .subMenuArrow2').removeClass('active');
            } else {
                parentLi.find('.subMenu').first().slideDown(300);
                parentLi.addClass('active');
                $(this).children('.subMenuArrow, .subMenuArrow2').addClass('active');
            }
        });

        if ($('#homepageFlag').length > 0) {
            lib.mainMenu.homepage = true;
        } else {
            lib.mainMenu.homepage = false;
        }
    },
    switchActive: function switchActive(element) {
        const self = this;
        const shouldHide = element.hasClass('active');

        if (lib.mainMenu.homepage && shouldHide) {
            if (element.data('display') === 'searchWrap') {
                return false;
            }

            $('#searchBtn').click();
        } else {
            $('.headerToggle').hide();
            $('#searchBtn, #menuBtn, #languageSwitch').removeClass('active');

            if (shouldHide) {
                return false;
            }

            if (element.data('display') === 'searchWrap' && !element.data('loaded')) {
                $('#searchWrap').show();
                $('.loader32w').show();

                $.get(self.options.searchFormUrl, { 'search-form-type': self.options.searchFormType })
                    .then((data) => {
                        element.data('loaded', true);
                        $('#searchBox').html(data.searchForm);
                        $('.loader32w').hide();
                    }).then(() => {
                        window.parent.postMessage(heightChanged(), '*');
                        window.parent.postMessage(legacyHeightChanged(document), '*');
                    });
            }

            if (element.data('display') === 'mainMenuWrap') {
                lib.user.menuUserData();
            }

            $(`#${element.data('display')}`).slideDown(300);
            element.addClass('active');
        }
        return true;
    },
};

lib.newsletterForm = {
    config: {
        form: '.newsletterForm',
        menuContainer: '#newsletterMenu',
        footerContainer: '#newsletterFooter',
        menuEmail: '#newsletterMenuEmail',
        footerEmail: '#newsletterFooterEmail',
        confirmEmail: '#newsletterFooterConfirmEmail', // honeypot
        subscribeUrl: '',
        subscribeSuccessText: '',
    },
    formHtml: [],
    container: [],
    email: [],
    init: function init(options) {
        const self = this;
        $.extend(self.config, options);

        self.formHtml.Menu = $(self.config.menuContainer).prop('outerHTML');
        self.formHtml.Footer = $(self.config.footerContainer).prop('outerHTML');

        self.container.Menu = self.config.menuContainer;
        self.container.Footer = self.config.footerContainer;

        self.email.Menu = self.config.menuEmail;
        self.email.Footer = self.config.footerEmail;

        self.initEvents();
    },
    initEvents: function initEvents() {
        const self = this;

        $(document).on('submit', self.config.form, function submitForm() {
            const $form = $(this);
            const formSource = $form.data('source');
            const formData = `${$form.serialize()}&formSource=${formSource}`;

            $.ajax({
                type: 'POST',
                url: self.config.subscribeUrl,
                data: formData,
                success: function subscribeSuccess(data) {
                    const isSuccess = $(data).find('form').data('success');

                    if (isSuccess) {
                        self.showSuccessMessageFor(formSource, 3000);
                        ga('send', 'event', 'Naslovnica', 'Newsletter', `Newsletter${formSource}`);
                    }

                    // obnovi izgled template-a
                    $($form).parent().parent().html(data);
                },
            });

            return false;
        });
    },
    showSuccessMessageFor: function showSuccessMessageFor(formSource, miliseconds) {
        const self = this;

        // unesi email parametar u prevedenu poruku za uspjeh
        const successText = self.config.subscribeSuccessText.replace('&&1&&', $(self.email[formSource]).val());

        // ugradi konačnu poruku za uspjeh u template za uspjeh te s tim zamjeni formu
        $(self.container[formSource]).replaceWith(`<div class='newsletterSuccess'>${successText}</div>`);

        // nakon milisekundi zamjeni poruku za uspjeh s početnom formom
        setTimeout(() => {
            $('.newsletterSuccess').replaceWith(self.formHtml[formSource]);
        }, miliseconds);
    },
};

lib.errorMessages = {
    display: function display(element, attribute) {
        $('#errorList').append(`<li>${element.data(attribute)}</li>`);
    },
    displayError: function displayError(element, attribute) {
        $('#errorList').html('');
        this.display(element, attribute);
        $('#errorBar').show();
    },
};

lib.shortlist = {
    config: {
        unitName: false,
        urlAdd: '',
        urlRemove: '',
        urlRemoveAll: '',
        urlCheck: '',
    },
    init: function init(options) {
        const self = this;
        self.config = options;

        if (self.config.unitName) {
            self.checkUnit(self.config.unitName);
        }

        self.initEvents();
    },
    initEvents: function initEvents() {
        const self = this;
        $(document).on('click', '.shortlistBtn', function shortListBtnClick(e) {
            e.preventDefault();
            const btn = $(this);

            if (btn.hasClass('inShortlist')) {
                self.removeUnit(btn.data('unitname'));
                btn.removeClass('inShortlist');
            } else {
                self.addUnit(btn.data('unitname'));
                btn.addClass('inShortlist');
            }
        });
    },
    checkUnit: function checkUnit(unitName) {
        const self = this;
        $.get(self.config.urlCheck, {
            unit_name: unitName,
        }, (response) => {
            if (response === true) {
                $('.shortlistBtn').addClass('inShortlist');
            } else if (response === 'useLocalStorage') {
                if ($.support.storage) {
                    let shortlist;
                    if ($.localStorage.isSet('adriatic_shortlist')) {
                        shortlist = $.localStorage.get('adriatic_shortlist');
                    } else {
                        shortlist = [];
                    }

                    if ($.inArray(unitName, shortlist) >= 0) {
                        $('.shortlistBtn').addClass('inShortlist');
                    }
                } else {
                    $('.shortlistBtn').hide();
                }
            }
        });
    },
    addUnit: function addUnit(unitName) {
        const self = this;
        $.get(self.config.urlAdd, {
            unit_name: unitName,
        }, (response) => {
            if (response === true) {
                lib.user.menuUserData();
            }

            if (response === 'useLocalStorage') {
                if ($.support.storage) {
                    let shortlist;
                    if ($.localStorage.isSet('adriatic_shortlist')) {
                        shortlist = $.localStorage.get('adriatic_shortlist');
                    } else {
                        shortlist = [];
                    }

                    shortlist.push(unitName);
                    $.localStorage.set('adriatic_shortlist', shortlist);
                    lib.user.menuUserData();
                }
            }
        });
    },
    removeUnit: function removeUnit(unitName) {
        const self = this;
        $.get(self.config.urlRemove, {
            unit_name: unitName,
        }, (response) => {
            if (response === true) {
                lib.user.menuUserData();
            }
            if (response === 'useLocalStorage') {
                if ($.support.storage) {
                    let shortlist;
                    if ($.localStorage.isSet('adriatic_shortlist')) {
                        shortlist = $.localStorage.get('adriatic_shortlist');
                    } else {
                        shortlist = [];
                    }

                    if (shortlist.length > 0) {
                        const index = $.inArray(unitName, shortlist);
                        if (index >= 0) {
                            shortlist.splice(index, 1);
                            $.localStorage.set('adriatic_shortlist', shortlist);
                            lib.user.menuUserData();
                        }
                    }
                }
            }
        });
    },
};

lib.eventTracking = {
    init: function init() {
        $(document).on('click', '[data-tracking-category]', function sendGATrackingInfo() {
            const elem = $(this);
            let label = elem.data('tracking-label');
            let value = jQuery.trim(elem.data('tracking-value'));

            if (label === undefined) {
                label = '';
            }

            if (typeof (ga) !== 'undefined') {
                // value ne smije biti string (ne smije biti npr. iznos sa oznakom valute)
                // i ne smije sadrzavati decimalnu tocku
                // Iako se ga request uredno vidi u debuggeru ne znaci da ce se pojaviti u GA reportima
                if (value !== undefined && !Number.isNaN(parseInt(value, 10))) {
                    value = parseInt(value, 10);
                    ga(
                        'send',
                        'event',
                        jQuery.trim(elem.data('tracking-category')),
                        jQuery.trim(elem.data('tracking-action')),
                        jQuery.trim(label),
                        value,
                    );
                } else {
                    ga(
                        'send',
                        'event',
                        jQuery.trim(elem.data('tracking-category')),
                        jQuery.trim(elem.data('tracking-action')),
                        jQuery.trim(label),
                    );
                }
            }
        });
    },
};

lib.accordions = {
    props: {
        activeIndex: 0,
        positions: [],
    },
    init: function init(options) {
        const self = this;
        self.calculatePositions(options);

        // Otvori prvi element ili sve elemente accordiona
        if (options.showFirstItem) {
            self.showFirstItem(options);
        } else if (options.openAllItems) {
            self.openAllItems(options);
        }

        $(window).on('orientationchange', () => {
            // Preračunaj pozicije nakon promjene dimenzija ekrana
            self.calculatePositions(options);
        });

        $(`.${options.headerClass}`).on('click', function headerClick() {
            const that = $(this);

            // Ako je accordion aktivan? zatvori ga
            if (that.hasClass('active')) {
                self.close(that, options, 300);
            } else { // ako je odabrani accordion zatvoren? otvori ga i zatvori prethodno otvoreni accordion
                // isključi (zatvori) accordion
                if (options.closeOthers && self.props.activeIndex !== 0) {
                    self.close($(`#${options.headerIdPrefix}${self.props.activeIndex}`), options, 300);
                }

                self.open(that, options);
            }
        });
    },
    findActive: function findActive(options) {
        const accordion = $(`.${options.headerClass}.active`);

        if (accordion.length) {
            return accordion;
        }

        return null;
    },
    close: function close(accordion, options, speed) {
        accordion.removeClass('active');
        accordion.children('.accArrow').removeClass('active');
        $(`#${options.boxIdPrefix}${accordion.data('index')}`).slideUp(speed, () => {
            window.parent.postMessage(heightChanged(), '*');
            window.parent.postMessage(legacyHeightChanged(document), '*');
        });
        this.props.activeIndex = 0;
    },
    open: function open(accordion, options) {
        const { positions } = this.props;

        accordion.addClass('active');
        accordion.children('.accArrow').addClass('active');
        $(`#${options.boxIdPrefix}${accordion.data('index')}`).slideDown(300, () => {
            window.parent.postMessage(heightChanged(), '*');
            window.parent.postMessage(legacyHeightChanged(document), '*');
        });
        this.props.activeIndex = accordion.data('index');
        // Pozicioniraj akordion na vrh ekrana
        $('body').scrollTop(positions[accordion.data('index')].top);
    },
    showFirstItem: function showFirstItem(options) {
        const firstAccordion = $(`.${options.headerClass}:first`);
        firstAccordion.addClass('active');
        $(`#${options.boxIdPrefix}${firstAccordion.data('index')}`).slideDown(300);
        this.props.activeIndex = firstAccordion.data('index');
    },
    calculatePositions: function calculatePositions(options) {
        const { positions } = this.props;
        const accordion = this.findActive(options);

        if (accordion) {
            this.close(accordion, options, 0);
        }

        $.each($(`.${options.headerClass}`), (key, value) => {
            const currentAccordion = $(value);
            positions[currentAccordion.data('index')] = currentAccordion.offset();
        });

        if (accordion) {
            this.open(accordion, options);
        }
    },
    openAllItems: function openAllItems(options) {
        $.each($(`.${options.headerClass}`), (key, value) => {
            const accordion = $(value);
            accordion.addClass('active');
            accordion.children('.accArrow').addClass('active');
            $(`#${options.boxIdPrefix}${accordion.data('index')}`).slideDown(300);
        });
    },
};

lib.user = {
    menuUserData: function menuUserData() {
        return $.get(lib.mainMenu.options.userDataUrl, (userDataHtml) => {
            if ($('.userDataMenuItem').length) {
                $('.userDataMenuItem').remove();
            }

            $('#menuItemAfterUserData').before(userDataHtml);

            if (!$('#slCounter').data('userloggedin')) {
                if ($.support.storage) {
                    let shortlist;
                    if ($.localStorage.isSet('adriatic_shortlist')) {
                        shortlist = $.localStorage.get('adriatic_shortlist');
                    } else {
                        shortlist = [];
                    }

                    $('#slCounter').html(shortlist.length);
                }
            }
        });
    },
};

lib.cookieNotice = {
    cookiePolicyUrl: null,
    init: function init(options) {
        const self = this;
        const cookieNotice = $('.noticeCookiesUse');

        // Cookies notice EU
        if (Cookies.get('allow_cookie_use') === undefined) {
            cookieNotice.removeClass('hidden');
            self.initializeCookiesPolicy();
            self.cookiePolicyUrl = options.cookiePolicyUrl;
        }

        $('#cookieCloseBtn').click(() => {
            cookieNotice.remove();
            Cookies.set('allow_cookie_use', true, {
                path: '/',
                expires: 365,
            });
        });
    },
    initializeCookiesPolicy: function initializeCookiesPolicy() {
        const self = this;
        // AJAX poziv cookiePolicy
        $(document).on('click', '.cookiesPolicy', (e) => {
            e.preventDefault();
            const scriptUrl = self.cookiePolicyUrl;

            $.ajax({
                type: 'POST',
                url: scriptUrl,
                success: function success(data) {
                    if (data !== '') {
                        openModal(data, { overlayCss: ['cookiePrivacyPolicy'] });
                    }
                },
            });
        });
    },
};

lib.ToastManager = {
    config: {
        time: 3000,
    },
    _messageEventHandler: () => {},

    add: function add(type, message, time) {
        const self = this;
        const toastWrap = $('.toastWrap');
        let toastMessage = null;
        let delayTime = time;

        if (delayTime === undefined) {
            delayTime = calculateToastMessageDuration(message, self.config.time);
        }

        if (isFrame()) {
            const setToastWrapStyleTop = (offset) => {
                const toastWrapStyleTop = offset > 0 ? offset : 0;
                $(toastWrap).css('top', toastWrapStyleTop + 10);
            };
            getFrameOffset().then((offset) => {
                if (offset !== undefined) {
                    setToastWrapStyleTop(offset);
                }
            });

            window.removeEventListener('message', this._messageEventHandler, false);
            this._messageEventHandler = function handleMessageFromFrame({ data }) {
                const dataAsObject = getMessageDataAsObject(data);
                if (dataAsObject.type === FRAME_OFFSET_CHANGED) {
                    setToastWrapStyleTop(dataAsObject.offset);
                }
            };
            window.addEventListener('message', this._messageEventHandler, false);
        }

        $(toastWrap).append(`<div class="toastMsg">${message}</div>`);

        toastMessage = new ToastMessage(type, message, delayTime);
        if (type === 'error') {
            delayTime = 99999;
        }

        toastMessage.showMsg(500);
        toastMessage.closeToast();
        toastMessage.hideAfter(delayTime);
    },
};

lib.GAdimensions = {
    sendHrental: function sendHrental(objId, pageType, totalValue, startDate, endDate) {
        const customData = {
            hitType: 'event',
            eventCategory: 'Custom dimensions',
            eventAction: pageType,
            nonInteraction: 1,
            dimension1: objId,
            dimension2: pageType,
        };
        if (totalValue !== '') { customData.dimension3 = totalValue; }
        if (startDate !== '') { customData.dimension4 = startDate; }
        if (endDate !== '') { customData.dimension5 = endDate; }
        lib.GAdimensions.checkLoadedAndSend(customData);
    },
    checkLoadedAndSend: function checkLoadedAndSend(dimensionsData) {
        if (typeof (ga) !== 'undefined') {
            ga('send', dimensionsData);
        } else {
            setTimeout(() => { lib.GAdimensions.checkLoadedAndSend(dimensionsData); }, 1000);
        }
    },
};

(function localStorageTest() {
    const mod = 'adriatic.local.storage.test';
    try {
        localStorage.setItem(mod, mod);
        localStorage.removeItem(mod);
        $.support.storage = true;
    } catch (e) {
        $.support.storage = false;
    }
}());
